<tlk-banner type="info">
	<div tlkBannerBody class="rx-intuitive-bridge-banner">
		<span class="rx-intuitive-bridge-banner__message">
			{{ 'TeethDiagram.BridgeSelectTeethToStart' | translate }}
		</span>
		<tlk-checkbox
			class="rx-intuitive-bridge-banner__checkbox"
			(changeEvent)="onDontShowAgainChanged()"
		>
			{{ 'Popup.DontShowAgainTitle' | translate }}
		</tlk-checkbox>
		<div class="rx-intuitive-bridge-banner__separator"></div>
		<button
			tlkButton
			variant="ghost"
			size="m"
			class="rx-intuitive-bridge-banner__close-btn"
			[attr.aria-label]="'TeethDiagram.BannerCloseAriaText' | translate"
			(click)="onCloseClicked()"
		>
			<tlk-close-empty-icon />
		</button>
	</div>
</tlk-banner>
